import { gql, useLazyQuery } from "@apollo/client"
import { Toast, useToast } from "@oysterhr/ui"
import { QueryTextTranslationArgs, TextTranslation } from "@oysterhr/schema"

const TranslationAPIQuery = gql`
  query SharedTranslationAPIQuery(
    $sourceLanguage: TranslationsLanguageCodeEnum!
    $targetLanguage: TranslationsLanguageCodeEnum!
    $text: String!
    $metadata: TextTranslationMetadataInput!
  ) {
    textTranslation(
      sourceLanguage: $sourceLanguage
      targetLanguage: $targetLanguage
      text: $text
      metadata: $metadata
    ) {
      translatedText
    }
  }
`

type TranslateParams = QueryTextTranslationArgs & {
  callback?: (result: TextTranslation) => void
}

export function useTranslationAPI() {
  const toast = useToast()
  const [query, options] = useLazyQuery<
    { textTranslation: TextTranslation },
    QueryTextTranslationArgs
  >(TranslationAPIQuery)

  const translate = async (params: TranslateParams) => {
    const response = await query({
      variables: params,
      fetchPolicy: "no-cache",
    })

    if (response.error) {
      toast({
        render: (
          <Toast variation="error">
            <Toast.Content>There was an error translating the job title field</Toast.Content>
          </Toast>
        ),
      })
    }
    if (response.data) {
      params.callback?.(response.data.textTranslation)
    }
  }

  return {
    translate,
    ...options,
  }
}
